import React from 'react'
import { useSelector } from 'react-redux'
import adminLogo from '../../resources/Logo-admin.png'
import logo from '../../resources/Logo.png'
import { withRouter } from 'react-router'
import styled from 'styled-components'

function Logo(props) {
  const onClick = () => {
    props.history.push(`${process.env.PUBLIC_URL}/`)
  }
  const { user: { organisation_id: orgID } = {} } = useSelector(state => state.authentication)
  const value = orgID ? logo : adminLogo

  return (
    <LogoImg paddingTop={value === logo ? '8px' : '0px'} onClick={onClick} src={value} alt='Healthera Logo' />
  )
}

export default withRouter(Logo)

const LogoImg = styled.img`
  width: 125px;
  cursor: pointer;
  padding-top: ${ props => props.paddingTop ? props.paddingTop : `0px`};
`
